module.exports = __webpack_public_path__ + "static/img/img-10.f9273508.png";